import { useTranslation } from 'react-i18next';
import type { Goal } from '@horizon/shared';

/**
 * Подпись под полосой прогресса зависит от режима. Счётчик задач рядом с
 * прогрессом по ключевому результату противоречил бы полосе: 24 % при
 * «0 из 0 задач» читается как ошибка.
 */
export function GoalMeasure({ goal }: { goal: Goal }) {
  const { t } = useTranslation();

  if (goal.progressMode === 'metric') {
    return (
      <span className="tabular-nums">
        {t('goal.metricOf', {
          current: goal.metricCurrent ?? 0,
          target: goal.metricTarget ?? 0,
        })}
      </span>
    );
  }

  if (goal.progressMode === 'manual') {
    return <span>{t('goal.manualHint')}</span>;
  }

  return (
    <span>{t('goal.tasksDone', { done: goal.taskCounts.done, total: goal.taskCounts.total })}</span>
  );
}
